import { render, staticRenderFns } from "./SchoolManage.vue?vue&type=template&id=d5c4797c&scoped=true"
import script from "./SchoolManage.vue?vue&type=script&lang=js"
export * from "./SchoolManage.vue?vue&type=script&lang=js"
import style0 from "./SchoolManage.vue?vue&type=style&index=0&id=d5c4797c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c4797c",
  null
  
)

export default component.exports